let timer;
export default {
    async login(context, payload) {
        return context.dispatch('auth', payload);
    },

    async auth(context, payload) {
        const url =
            `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}${process.env.VUE_APP_ROOT_API_AUTH}`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                grant_type: 'password',
                scope: 'driver',
                code: 'code',
                username: payload.username,
                password: payload.password,
                client_id: process.env.VUE_APP_CLIENT_ID,
                client_secret: process.env.VUE_APP_CLIENT_SECRET
            })
        });
        const responseData = await response.json();

        if (!response.ok || responseData.error) {
            const error = new Error(
                responseData.error_description || 'Failed to authenticate. Check your login data.'
            );
            throw error;
        }

        const expiresIn = +responseData.expires_in * 1000;
        const expirationDate = new Date().getTime() + expiresIn -  2 * 60 * 1000;

        localStorage.setItem('token', responseData.access_token);
        localStorage.setItem('refreshToken', responseData.refresh_token);
        localStorage.setItem('userName', payload.username);
        localStorage.setItem('tokenExpiration', expirationDate);

        timer = setTimeout(function () {
            context.dispatch('refreshToken');
        }, expiresIn);

        context.commit('setUser', {
            token: responseData.access_token,
            userName: payload.username
        });

        await context.dispatch('getInitData');

    },

    async refreshToken(context) {
        const userName = localStorage.getItem('userName');
        const refreshtoken = localStorage.getItem('refreshToken');
        if (!refreshtoken || !userName) {
            context.dispatch('autoLogout');
            return;
        }
        let url =
            `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}${process.env.VUE_APP_ROOT_API_AUTH}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                grant_type: 'refresh_token',
                scope: 'driver',
                refresh_token: refreshtoken,
                client_id: process.env.VUE_APP_CLIENT_ID,
                client_secret: process.env.VUE_APP_CLIENT_SECRET
            })
        });
        const responseData = await response.json();

        if (!response.ok || responseData.error) {
            const error = new Error(
                responseData.message || 'Failed to re-authenticate.'
            );
            await context.dispatch('autoLogout');
            throw error;
        }

        const expiresIn = +responseData.expires_in * 1000;
        const expirationDate = new Date().getTime() + expiresIn -  2 * 60 * 1000;

        localStorage.setItem('token', responseData.access_token);
        localStorage.setItem('refreshToken', responseData.refresh_token);
        localStorage.setItem('tokenExpiration', expirationDate);

        timer = setTimeout(function () {
            context.dispatch('refreshToken');
        }, expiresIn);

        context.commit('setUser', {
            token: responseData.access_token,
            userName: userName
        });
        await context.dispatch('getInitData');
    },
    async tryLogin(context) {
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refreshToken');
        const userName = localStorage.getItem('userName');
        const tokenExpiration = localStorage.getItem('tokenExpiration');

        const expiresIn = +tokenExpiration - new Date().getTime();

        if (!refreshToken) {
            return;
        }

        if ((!expiresIn || expiresIn < 0) && refreshToken) {
            await context.dispatch('refreshToken');
            return;
        }

        timer = setTimeout(async function () {
            await context.dispatch('refreshToken');
        }, expiresIn);

        if (token && userName) {
            context.commit('setUser', {
                token: token,
                userName: userName
            });
            await context.dispatch('getInitData');
        }
    },
    async getInitData(context) {
        try {
            await Promise.all([
                context.dispatch('user/getUserData'),
                context.dispatch('ritten/getRitten'),
                //context.dispatch('ritten/getConfirmRitten')
            ]);
        } catch (e) {
            await context.dispatch('autoLogout');
            throw e;
        }
    },
    logout(context) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userName');
        localStorage.removeItem('tokenExpiration');

        clearTimeout(timer);

        context.commit('setUser', {
            token: null,
            userName: null
        });
        context.dispatch('user/clearUserData');
        context.dispatch('ritten/clearRitten');
    },
    autoLogout(context) {
        context.dispatch('logout');
        context.commit('setAutoLogout');
    }
}